import {
  Collapse,
  Grid,
  HStack,
  Icon,
  Text,
  VStack,
  Link,
} from "@chakra-ui/react";

import React, { FC } from "react";
import { BiChevronDown, BiChevronRight, BiChevronUp } from "../../customIcons";

type ProductSectionType = {
  categoryName: string;
  categorySlug: string;
  brands: any;
};

const ProductSection: FC<ProductSectionType> = ({
  categoryName,
  brands,
  categorySlug,
}) => {
  const [show, setShow] = React.useState<boolean>(false);

  const handleToggle = () => setShow(!show);
  return (
    <VStack w="100%">
      <HStack
        width="100%"
        h="40px"
        bg={show ? "#fff" : "#f3f6f4"}
        cursor="pointer"
        onClick={handleToggle}
        justifyContent="space-between"
      >
        <Text
          fontWeight={show ? "600" : "400"}
          fontSize="14px"
          color={show ? "#1A212D" : "#4A5568"}
          textDecoration={show ? "underline" : "none"}
        >
          {categoryName}
        </Text>
        <Icon
          as={show ? BiChevronUp : BiChevronDown}
          width="18px"
          fill="#CB809E"
          height="18px"
        />
      </HStack>

      <Collapse
        in={show}
        style={{
          width: "100%",
        }}
      >
        <Grid
          templateColumns={{
            base: "repeat(2, 1fr)",
          }}
        >
          {brands?.map((item: any, index: any) => (
            <Link key={index} href={`/${item.slug}/`} style={{ flex: 1 }}>
              <Text
                fontWeight="500"
                _hover={{ textDecoration: "underline" }}
                m="2px"
                fontSize="16px"
              >
                {item.name}
              </Text>{" "}
            </Link>
          ))}
        </Grid>
        <Link href={`/${categorySlug}/`}>
          <HStack pt="12px" pb="24px" alignItems="center">
            <Text fontSize="16px" color="#BB5D82" fontWeight="600">
              Go to {categoryName} page
            </Text>
            <Icon
              as={BiChevronRight}
              width="24px"
              height="24px"
              fill="#BB5D82"
            />
          </HStack>
        </Link>
      </Collapse>
    </VStack>
  );
};

export default ProductSection;
